<div ng-controller="accountController as ctrl" class="modal-view ">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>